import 'slick-carousel';
import slickCss from 'slick-carousel/slick/slick.css';

class IntroCarousel {
  constructor($main) {
    console.log('IntroCarousel: constructor');
    if (!this.initDomElements($main)) return false;
    this.initCarousel();
  }

  initDomElements($main) {
    this.domElements = {};
    this.domElements.main = $main;
    if (this.domElements.main.length < 1) return false;
    this.domElements.items = this.domElements.main.find('.intro-carousel__items');
    this.domElements.navigation = this.domElements.main.find('.intro-carousel__control');
    this.domElements.logo = this.domElements.main.find('.intro-carousel__logo');
    return true;
  }

  initCarousel() {
    const slickConfig = {
      dots: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 1000,
      fade: true,
      pauseOnHover: false,
      autoplay: true,
      autoplaySpeed: 4000,
      adaptiveHeight: true,
      appendArrows: this.domElements.navigation,
      appendDots: this.domElements.navigation
    };

    this.domElements.items.slick(slickConfig);

    // Add event listener for beforeChange event to rotate the logo
    this.domElements.items.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      if (this.domElements.logo && this.domElements.logo.length > 0) {
        this.rotateLogo();
      }
    });
  }

  rotateLogo() {
    this.domElements.logo.css({
      'transition': 'transform 1s ease-in-out',
      'transform': 'rotate(360deg)'
    });

    setTimeout(() => {
      this.domElements.logo.css({
        'transition': 'none',
        'transform': 'rotate(0deg)'
      });
    }, 1000);
  }
}

export default IntroCarousel;
